export default [
  {
    path: "/plantillasContenido",
    component: () => import("@/views/plantillasContenido/Listar.vue"),
  },
  {
    path: "/plantillasContenido/crear",
    component: () => import("@/views/plantillasContenido/Crear.vue"),
  },
  {
    path: "/plantillasContenido/editar/:id",
    component: () => import("@/views/plantillasContenido/Editar.vue"),
  },
];
